/**
 * Created by Vladislav on 17.10.2024.
 */

const Map2dEdges = function (map) { 
    this.map = map;

    this.edges = {};

    const tilesTexture = Map2d.getTilesTexture(map.tilesSkin);
    this.unused = Object.keys(bundles[tilesTexture].frames).filter((name) => name.includes("edge"));

    this.terrainsAreas = {};
    map.map(map.layers[Map2d.LAYER_GROUND], (cell, x, y) => {
        this.setTerrain(x, y);
    });

    Object.keys(this.terrainsAreas).forEach((code) => {
        BorderRenderer.place(
            this.terrainsAreas[code],
            this.edgesPlacement.bind(this)
        );
    });
};

Map2dEdges.prototype.setTerrain = function (x, y) {
    const terrainCode = this.getGroundTerrainCode(x, y);

    if (terrainCode) {
        this.terrainsAreas[terrainCode] = this.terrainsAreas[terrainCode] || [];
        this.terrainsAreas[terrainCode][y] = this.terrainsAreas[terrainCode][y] || [];
        this.terrainsAreas[terrainCode][y][x] = terrainCode;
    }
};

Map2dEdges.prototype.edgesPlacement = function (borders, cell) {
    const map = Map2d.currentMap;
    borders.forEach((border) => {
        const x = border.borderCell.x;
        const y = border.borderCell.y;

        if (x < 0 || y < 0 || x >= Map2d.currentMap.getWidth() || y >= Map2d.currentMap.getHeight()) {
            return;
        }

        if (cleverapps.meta.getSelectedLocation().locationConfig.edgesAroundEmpty) {
            if (!this.isEmptyTerrain(x, y)) {
                return false;
            }
        } else {
            // eslint-disable-next-line no-lonely-if
            if (!map.isGround(x, y) && !map.isImpassableGround(x, y)) {
                return;
            }
        }

        if (this.getGroundTerrainCode(cell.x, cell.y) === Map2d.TERRAIN_GREEN && this.getGroundTerrainCode(x, y)) {
            return;
        }

        const name = `edge_${border.name}`;

        let amount = 0;
        while (map.getTerrainFrames(cell.x, cell.y)[`${name}_${amount}`]) {
            amount++;
        }

        let result;

        if (amount) {
            const index = (x + y) % amount;
            result = map.getTerrainFrameData(`${name}_${index}`, cell.x, cell.y);
        } else {
            result = map.getTerrainFrameData(name, cell.x, cell.y);
        }

        if (!result.res) {
            return;
        }

        result.type = border.name;

        if (!this.edges[y]) {
            this.edges[y] = {};
        }

        this.edges[y][x] = this.edges[y][x] || [];
        this.edges[y][x].push(result);

        this.filterLockedTypes(x, y);

        if (this.unused && this.unused.includes(result.res.key)) {
            this.unused.splice(this.unused.indexOf(result.res.key), 1);
        }
    });
};

Map2dEdges.prototype.filterLockedTypes = function (x, y) {
    let locked = [];
    this.edges[y][x].forEach((item) => {
        if (Map2dEdges.locks[item.type]) {
            locked = locked.concat(Map2dEdges.locks[item.type]);
        }
    });

    this.edges[y][x] = this.edges[y][x].filter((item) => !locked.includes(item.type));
};

Map2dEdges.prototype.getEdges = function (x, y) {
    return this.edges[y] && this.edges[y][x];
};

Map2dEdges.prototype.getUnusedEdges = function () {
    return this.unused || [];
};

Map2dEdges.prototype.onEdit = function (x, y) {
    Object.keys(this.terrainsAreas).forEach((code) => {
        if (this.terrainsAreas[code][y] && this.terrainsAreas[code][y][x]) {
            this.terrainsAreas[code][y][x] = undefined;
        }
    });

    this.setTerrain(x, y);

    const neighbours = BorderRenderer.getNeighbours(x, y).concat({ x, y });

    neighbours.forEach((neighbour) => {
        if (this.edges[neighbour.y]) {
            delete this.edges[neighbour.y][neighbour.x];
        }
    });
    const terrainCode = this.getGroundTerrainCode(x, y);

    if (terrainCode) {
        BorderRenderer.place(
            this.terrainsAreas[terrainCode],
            this.edgesPlacement.bind(this),
            { part: neighbours }
        );
    }
};

Map2dEdges.prototype.getGroundTerrainCode = function (x, y) {
    const terrain = this.map.getTerrainCode(x, y);

    if (this.map.isGround(x, y) || terrain === Map2d.TERRAIN_ROAD) {
        return terrain !== Map2d.TERRAIN_EMPTY ? terrain : undefined;
    }
};

Map2dEdges.prototype.isEmptyTerrain = function (x, y) {
    const terrain = this.map.getTerrainCode(x, y);

    return terrain === Map2d.TERRAIN_EMPTY;
};

Map2dEdges.prototype.addViews = function (x, y) {
    const edges = this.getEdges(x, y);

    if (!edges) {
        return;
    }

    edges.forEach(function (edge) {
        let view = edge.getView && edge.getView();

        if (!view) {
            view = ViewReader.createTopYAnchorElement(edge);
            edge.getView = view.createListener(() => view);

            this.map.getMapView().addTile(Map2d.LAYER_GROUND, x, y, view);
        }
    }, this);
};

Map2dEdges.locks = {
    inner_up_left: ["up", "right"],
    inner_up_right: ["up", "left"],
    inner_down_left: ["down", "right"],
    inner_down_right: ["down", "left"]
};
